import React, { Component } from 'react';
import CONSTANTS from '../../constants';

class HappyHoureTitle extends Component {

  render() {

    const happyHoureMessage = (window.innerWidth <= 800 ? CONSTANTS.LABELS.multislots_happy_hours_mobile : CONSTANTS.LABELS.multislots_happy_hours_desktop)
    return (
      <div className="offre-message style-mark">
        <p tabIndex="0" className="message-headline" dangerouslySetInnerHTML={{ __html: happyHoureMessage }} />
      </div>
    );
  }
}

export default HappyHoureTitle;
